export default {
    computed: {
        configurationSettings() {
            return this.getParsedData(
                this.settingsKey,
                this.settings.configurations,
                'object'
            )
        },

        settings() {
            return this.$store.state.company.settings
        },

        settingsKey() {
            return this.$store.state.company.settingKeys[this.settingsKeyName]
        },
    },
    watch: {},
    mounted() {
        this.$store.dispatch('company/fetch')
    },
    methods: {
        getParsedData(key, configurations, valueType = 'string') {
            try {
                const data = configurations.find(x => x.key == key)
                switch (valueType) {
                    case 'array':
                    case 'object':
                        return JSON.parse(data.text_value)
                    case 'string':
                        return data.text_value
                    case 'int':
                        return parseInt(data.text_value, 10)
                }
            } catch (err) {
                switch (valueType) {
                    case 'array':
                        return []
                    case 'object':
                        return {}
                    case 'string':
                        return null
                    case 'int':
                        return null
                }
            }
        },
    },
}
